import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { Dropdown } from 'primereact/dropdown';
import { Message } from 'primereact/message';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';

import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioEmisor from '../servicios/ServicioEmisor';
import servicioArchivos from '../servicios/ServicioArchivos';
import servicioIdioma from '../servicios/ServicioIdiomaFecha';

export class ReporteFacturacion extends Component {

  constructor() {
    super();

    this.state = {
      reportes: {},
      emisores: [],
      erroresReportes: {}
    }

  }

  componentDidMount() {
    this.buscar_emisores();
  }

  buscar_emisores=()=>{
    servicioEmisor.buscarEmisores().then(response=>{
      this.setState({emisores:response.data.lista});
    })
  }

  asignarValoresObjeto = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
  }

  descargar_reporte_emisor=()=>{
    let {reportes}=this.state;
    let errores = this.validar_formulario(reportes);
    this.setState({ erroresReportes: errores });
    if (!Object.keys(errores).length) {
      let fechaIncial = reportes.fechaCreacion.getTime();
      let fechaFinal = reportes.fechaCertificacion.getTime();
      let cfdiObj = { fechaCreacion: fechaIncial, fechaCertificacion: fechaFinal};
      servicioArchivos.descargaArchivo("reportes/descargar_reporte_facturacion_series.json",  { ttCfdi: cfdiObj, tcEmisor:reportes.emisor  });
    }
  }

  validar_formulario=(reportes)=>{
    const erroresRequeridos = {};
    if (!reportes.emisor)
      erroresRequeridos.emisor = "El emisor es requerido";
    if (!reportes.fechaCreacion)
      erroresRequeridos.fechaCreacion = "La fecha inicial es requerida";
    if (!reportes.fechaCertificacion)
      erroresRequeridos.fechaCertificacion = "La fecha final es requerida";
    return erroresRequeridos;
  }

  render() {
    let { reportes, emisores,erroresReportes } = this.state;
    return (
      <div>
        <Growl ref={(el) => this.growl = el} />
        <div className="card card-w-title" style={{padding:'14px'}}>
          <h1 style={{marginBottom:'30px'}}>Reportes de Facturación</h1>
        </div>
        <div className="card card-w-title" style={{paddingBottom:'14px'}}>
        <div className="p-grid p-fluid">
          <div className="p-col-12" style={{display:'inline-grid'}}>
          <h4 style={{marginBottom:'20px', marginLeft:'5px'}}><strong>Generación de reportes:</strong></h4>
            <div className="p-grid form-group">
              <div className="p-col-12 p-md-4">
                <span className="md-inputfield">
                  <Dropdown name="reportes.emisor" options={emisores} value={reportes.emisor || ''} onChange={this.asignarValoresObjeto} placeholder="Seleciona emisor" optionLabel="rfc" className={erroresReportes.emisor ? 'p-error' : ''} />
                </span>
                {erroresReportes.emisor ? <div> <Message severity="error" text={erroresReportes.emisor} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-4">
                <span className="md-inputfield">
                  <Calendar id="fechaCreacion" name="reportes.fechaCreacion" value={reportes.fechaCreacion || ''} locale={servicioIdioma} onChange={this.asignarValoresObjeto} className={erroresReportes.fechaCreacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                  <label>Fecha inicio</label>
                </span>
                {erroresReportes.fechaCreacion ? <div> <Message severity="error" text={erroresReportes.fechaCreacion} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-4">
                <span className="md-inputfield">
                  <Calendar id="fechaCertificacion" name="reportes.fechaCertificacion" value={reportes.fechaCertificacion || ''} locale={servicioIdioma} onChange={this.asignarValoresObjeto} className={erroresReportes.fechaCertificacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                  <label>Fecha Final</label>
                </span>
                {erroresReportes.fechaCertificacion ? <div> <Message severity="error" text={erroresReportes.fechaCertificacion} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-4">

              </div>
              <div className="p-col-12 p-md-4">

              </div>
              <div className="p-col-12 p-md-4">
                <Button label="Descargar Excel" onClick={this.descargar_reporte_emisor} className="teal-btn flat-btn" />
              </div>
            </div>
          </div>


        </div>
        </div>

        </div>

        );
      }
    
}